import { Button,Spinner } from "react-bootstrap";
import React,{ useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const EditPhishingCompaign = ({ id }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false); // Loader state
    const navigate = useNavigate();
    const [userId] = useState(id);
    const [selectFile, setSelectFile] = useState(null);
    const [showFileUpload, setShowFileUpload] = useState(false);
    const [arabicError, setArabicError] = useState("");


    const handleArabicChange = (e) => {
        const { name, value } = e.target;
        // Allow Arabic letters, Arabic/English numbers, and spaces
        const arabicAndNumbersRegex = /^[\u0600-\u06FF0-9\s]+$/;
    
        if (value === "" || arabicAndNumbersRegex.test(value)) {
          setFormData({ ...formData, [name]: value });
          setArabicError(""); // Clear error
        } else {
          setArabicError(t("Please type in Arabic letters or numbers only."));
        }
      };

    const [formData, setFormData] = useState({
        name_ar: "",
        name_en: "",
        start_date: "",
        end_date: "",
        start_time:"",
        save_submitted_data: false,
        enable_attachment: false,
        attachment: null,
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectFile(file); 
        }
    };
    

    const handleBrowseClick = () => {
        document.getElementById("fileInput").click();
    };

    const fetchPhishingCompaign = async () => {
        try {
            if (!userId) {
                showToast(t("userIdRequired"), "error");
                return;
            }            

            const token = localStorage.getItem("userToken");
            const response = await fetch(`${api_url}/phishing-campaigns/${userId}`, {
                mode: 'cors',
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                }
            });

            if (!response.ok) {
                showToast(t("errorFetchingCampaignDetails"), "error");
                return;
            }
            
            const data = await response.json();
            
            if (!data.phishing_campaign) {
                showToast(t("noCampaignDataFound"), "error");
                return;
            }            
            const campaign = data.phishing_campaign;
            console.log("campaignstart_Date");
            setFormData({
                ...formData,
                name_ar: campaign.name_ar || "",
                name_en: campaign.name_en || "",
                start_date: campaign.start_date ? campaign.start_date.substring(0, 10) : "", 
                end_date: campaign.end_date ? campaign.end_date.substring(0, 10) : "",
                // template_id: campaign.template_id || null,
                start_time: campaign.start_time ? campaign.start_time : "",
                save_submitted_data: campaign.save_submitted_data || 0,
                enable_attachment: campaign.enable_attachment || 0,
                attachment: campaign.attachment || null,
            });

            // setShowFileUpload(campaign.enable_attachment === 1);
        } catch (err) {
            console.error("Error Details:", err); // Log error details for debugging
            showToast(t("somethingWentWrong"), "error");
        }        
    };

    useEffect(() => {
        fetchPhishingCompaign();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            const isChecked = checked ? 1 : 0;
            setFormData({ ...formData, [name]: isChecked });

            if (name === "enable_attachment") {
                const isChecked = checked ? 1 : 0;
                setFormData({ ...formData, [name]: isChecked });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

  const handleEditPhishingCompaign = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formattedStartTime = formData.start_time.trim().slice(0, 5);
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeRegex.test(formattedStartTime)) {
        showToast(t("InvalidTimeFormat"), "error");
        setIsLoading(false);
        return;
    }

    try {
        const token = localStorage.getItem("userToken");

        // Create FormData object
        // const data = new FormData();
        // data.append("name_ar", formData.name_ar.trim());
        // data.append("name_en", formData.name_en.trim());
        // data.append("start_date", formData.start_date);
        // data.append("end_date", formData.end_date);
        // data.append("start_time", formattedStartTime);
        // data.append("save_submitted_data", formData.save_submitted_data === 1 ? 1 : 0);
        // data.append("enable_attachment", formData.enable_attachment === 1 ? 1 : 0);
        // if (selectFile) {
        //     data.append("attachment", selectFile);
        // }
        const response = await fetch(`${api_url}/phishing-campaigns/${userId}`, {
            mode: "cors",
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`, // Replace token dynamically
            },
            body: JSON.stringify(formData),
            redirect: "follow"
        });
        const responseData = await response.json();

        if (response.ok) {
            showToast(t("phishingCampaignUpdatedSuccess"), "success");
            navigate(-1);
        } else {
            showToast(responseData.message || t("somethingWentWrong"), "error");
        }
    } catch (error) {
        console.error("Error:", error);
        showToast(t("somethingWentWrong"), "error");
    } finally {
        setIsLoading(false);
    }
};

    
    
    

    return (
        <div className="py-4" style={{ border: '1px solid #EAEAEA', borderRadius: '10px', padding: '0px 15px' }}>
            <form onSubmit={handleEditPhishingCompaign}>

                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">{t('Namear')}</label>
                            <input type="text" name="name_ar" className="form-control" onChange={handleArabicChange} value={formData.name_ar} required />

                            {arabicError && (
                            <div className="text-danger mt-1" style={{ fontSize: "0.9em" }}>
                                {arabicError}
                            </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">{t('Nameen')}</label>
                            <input type="text" name="name_en" className="form-control" onChange={handleChange} value={formData.name_en} required />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">{t('StartDate')}</label>
                            <input type="date" name="start_date" className="form-control" onChange={handleChange} value={formData.start_date} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                    <div className="mb-3">
                                    <label className="form-label">{t('Starttime')}</label>
                                    <input
                                        type="time"
                                        name="start_time"
                                        className="form-control"
                                        onChange={handleChange}
                                        value={formData.start_time}
                                        required
                                    />
                                </div>
                    </div>
                </div>
                <div className="mb-3">
                            <label className="form-label">{t('EndDate')}</label>
                            <input type="date" name="end_date" className="form-control" onChange={handleChange} value={formData.end_date} required />
                        </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-check mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name="enable_attachment"
                                checked={formData.enable_attachment === 1}
                                onChange={handleChange}
                                id="enable_attachment"
                            />
                            <label className="form-check-label" htmlFor="enable_attachment">
                                {t("EnableAttachment")}
                            </label>
                        </div>
                    </div>

                    <div className="col-md-6">
                    <div className="form-check mb-3">
                    <OverlayTrigger
    placement="top"
    overlay={
        <Tooltip 
            id="tooltip-save-submitted-data" 
            style={{ maxWidth: "550px", whiteSpace: "normal", padding: "10px", textAlign: "left" }}
        >
            This option will enable saving all data that are submitted in a phishing campaign. 
            Make sure you have the authority before enabling this option.
        </Tooltip>
    }
>
    <span>
        <input
            type="checkbox"
            className="form-check-input"
            name="save_submitted_data"
            checked={formData.save_submitted_data === 1}
            onChange={handleChange}
            id="save_submitted_data"
        />
        <label className="form-check-label ms-2" htmlFor="save_submitted_data">
            {t("SaveSubmittedData")}
        </label>
    </span>
</OverlayTrigger>

                </div>

                    </div>
                </div>

                {/* File Upload Field (Only Show if Enabled) */}
                {formData.enable_attachment === 1 && (
 <div className="mb-2">
 <label className="form-label">
     Upload PDF or ZIP File
 </label>

 <div
    className="form-control d-flex flex-column flex-md-row align-items-start align-items-md-center"
    style={{ padding: "10px", marginBottom: "10px", gap: "10px" }}
>
    {/* LEFT START: Button first */}
    <Button
        variant="secondary"
        size="sm"
        type="button"
        onClick={() => document.getElementById("fileInput").click()}
    >
        Choose File
    </Button>

    {/* File name after button */}
    <span className="text-break">
        {selectFile
            ? selectFile.name
            : formData.attachment
            ? formData.attachment.split("/").pop()
            : "No file chosen"}
    </span>

    <input
        id="fileInput"
        type="file"
        hidden
        accept=".pdf,.zip"
        onChange={handleFileChange}
    />
</div>
</div>
)}

<button type="submit" className="btn btn-primary" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <Spinner animation="border" size="sm" role="status" className="me-2" />
                                            {t('Update...')}
                                        </>
                                    ) : (
                                        t('UpdatePhishingCampaign')
                                    )}
                                </button>
            </form>
        </div>
    );
};

export default EditPhishingCompaign;
